<button mat-icon-button (click)="openDrawer()" aria-label="Abrir menú de cuenta">
    <span class="relative">
        @if (showAvatar && user?.avatarUrl) {
            <img class="h-7 w-7 rounded-full" [src]="user.avatarUrl" alt="Avatar" />
        } @else {
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'" class="text-white"></mat-icon>
        }
    </span>
</button>
